import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";

import axios from "../../axios";

import PersonalInfo from "./personalInfo";
import MyCourses from "./mycourses";
import MyReports from "./MyReports";
import BankDetails from "./BankDetails";
import AppliedClassesComponent from "./AppliedClasses/AppliedClassesComponent";
import { alertData } from "./../../states/alert";
import Faqs from "../faq";
import Support from "../support";
import FeedbackPopup from "./../feedback";
import "./myProfile.css";
import NewAddress from "./newAddressPage";
import SubscriptionComponent from "./Subscription/SubscriptionComponent";
import Attendance from "./Attendance";
import LogoutModal from "../../components/LogoutModal/LogoutModal";

export default function MyProfile() {
  const [alert, setAlert] = useAtom(alertData);
  const [activeNavigation, setActiveNavigation] = useState();
  const [reportsSubPage, setReportsSubPage] = useState(null);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate();

  const handleFeedbackSubmit = (data) => {
    console.log("User feedback:", data);
    axios
      .post("/v1/feedback", {
        ...data,
      })
      .then((response) => {
        console.log("🚀 ~ handleFeedbackSubmit ~ response.data:", response.data);
      })
      .catch((err) => {
        console.error("Error submitting feedback:", err);
      });
  };

  useEffect(() => {
    let jwt = JSON.parse(localStorage.getItem("homeshiksha-tutor-jwt"));
    if (!jwt) navigate("/");
    else setActiveNavigation(() => "personal");
  }, []);

  useEffect(() => {
    if (activeNavigation !== "reports") {
      setReportsSubPage(null);
    }
  }, [activeNavigation]);

  return (
    <main className="main">
      <section className="pathway-requestBtn--wrapper">
        <div className="pathway--wrapper">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            <img src="/homeicon.svg" alt="homeicon icon" width="18" height="17" />
          </div>
          <div>
            <img src="/rightArrow.svg" alt="rightArrow icon" width="11" height="11" />
          </div>
          <div className="pathway--btn">Account</div>
          <div>
            <img src="/rightArrow.svg" alt="rightArrow icon" width="11" height="11" />
          </div>
          <div className="pathway--btn">
            {activeNavigation === "personal"
              ? "Personal Info"
              : activeNavigation == "mycourses"
                ? "My Courses"
                : activeNavigation == "address"
                  ? "My Address"
                  : activeNavigation == "reports"
                    ? "My Reports"
                    : activeNavigation == "applied_classes"
                      ? "Applied Classes"
                      : activeNavigation == "bank_details"
                        ? "Bank Details"
                        : activeNavigation == "subscription"
                          ? "Subscription"
                          : activeNavigation == "faqs"
                            ? "FAQ's"
                            : activeNavigation == "support"
                              ? "Support"
                              : activeNavigation == "settings"
                                ? "Settings"
                                : ""}
          </div>
          {activeNavigation === "reports" && reportsSubPage === "earnings" && (
            <>
              <div>
                <img src="/rightArrow.svg" alt="rightArrow icon" width="11" height="11" />
              </div>
              <div className="pathway--btn">My earnings</div>
            </>
          )}
        </div>
      </section>
      <section className="personal-info--container">
        <div className="personal-info--navigation--wrapper">
          <div className="personal-info--navigation">
            <div className="personal-info--navigation">
              <div
                onClick={() => {
                  setActiveNavigation("personal");
                }}
                className={`${activeNavigation === "personal" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                Personal Info
              </div>
              <div
                onClick={() => {
                  setActiveNavigation("mycourses");
                }}
                className={`${activeNavigation === "mycourses" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                My Courses
              </div>
              {/* <div onClick={()=>{setActiveNavigation('children')}} className={`${(activeNavigation=='children')?'active-personal-info--navigation':'unactive-personal-info--navigation'}`}>My Children</div> */}
              <div
                onClick={() => {
                  setActiveNavigation("address");
                }}
                className={`${activeNavigation === "address" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                My Address
              </div>

              <div
                onClick={() => {
                  setActiveNavigation("reports");
                }}
                className={`${activeNavigation === "reports" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                My Reports
              </div>
              <div
                onClick={() => {
                  setActiveNavigation("attendance");
                }}
                className={`${activeNavigation === "attendance" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                Attendance
              </div>

              <div
                onClick={() => {
                  setActiveNavigation("applied_classes");
                }}
                className={`${activeNavigation === "applied_classes" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                Applied Classes
              </div>

              <div
                onClick={() => {
                  setActiveNavigation("bank_details");
                }}
                className={`${activeNavigation === "bank_details" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                Bank Details
              </div>

              <div
                onClick={() => {
                  setActiveNavigation("subscription");
                }}
                className={`${activeNavigation === "subscription" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                Subscription
              </div>

              <div
                onClick={() => {
                  setActiveNavigation("faqs");
                }}
                className={`${activeNavigation === "faqs" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                FAQ'S
              </div>
              <div
                onClick={() => {
                  setActiveNavigation("support");
                }}
                className={`${activeNavigation === "support" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                Support
              </div>
            </div>
            {/* <div onClick={()=>{setActiveNavigation('settings')}} className={`${(activeNavigation=='settings')?'active-personal-info--navigation':'unactive-personal-info--navigation'}`}>Settings</div> */}
            <div>
              <div
                onClick={() => {
                  setShowFeedbackPopup(true);
                  console.log("show feedback form");
                }}
                className={`${showFeedbackPopup ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
              >
                Give Feedback
              </div>
              {showFeedbackPopup && (
                <FeedbackPopup onClose={() => setShowFeedbackPopup(false)} onSubmit={handleFeedbackSubmit} />
              )}
              <div
                onClick={() => {
                  setShowLogoutModal(true);
                }}
                className={`${activeNavigation === "settings" ? "active-personal-info--navigation" : "unactive-personal-info--navigation"}`}
                style={{ cursor: "pointer" }}
              >
                Log Out
              </div>
            </div>
            {/* <div><NavLink to='/' >Log Out</NavLink></div> */}
          </div>
        </div>

        <div className="personal-info--content--page">
          {activeNavigation === "personal" ? <PersonalInfo /> : <></>}
          {activeNavigation === "children" ? <div>children</div> : <></>}

          {activeNavigation === "address" ? <NewAddress /> : <></>}
          {activeNavigation === "attendance" ? <Attendance /> : <></>}
          {activeNavigation === "reports" ? <MyReports onReportsSubPageChange={setReportsSubPage} /> : <></>}
          {activeNavigation === "applied_classes" ? <AppliedClassesComponent /> : <></>}
          {activeNavigation === "bank_details" ? <BankDetails /> : <></>}
          {activeNavigation === "subscription" ? <SubscriptionComponent /> : <></>}
          {activeNavigation === "mycourses" ? <MyCourses /> : <></>}
          {activeNavigation === "faqs" ? <Faqs /> : <></>}
          {activeNavigation === "support" ? <Support /> : <></>}

          {activeNavigation === "settings" ? <div>settings</div> : <></>}
        </div>
      </section>
      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={() => {
          localStorage.removeItem("homeshiksha-tutor-jwt");
          navigate("/");
          window.location.reload();
        }}
      />
    </main>
  );
}
